import type { ReactNode } from "react";

import { ThemeToggle } from "@/components/ThemeToggle";

/**
 * Shell del portal del cliente: una columna, con membrete y sin nada más.
 *
 * NO REUSA `AuthLayout`, y no es por gusto. Aquel es una pantalla partida con
 * el contenido en `max-w-sm`: alcanza para un formulario de login o para una
 * confirmación de un clic, que es lo que hace `AceptarCotizacion`. Acá el
 * cliente TRABAJA — trece documentos con sus adjuntos y un formulario de ocho
 * campos— y esa columna lo obligaría a scrollear una lista de una palabra de
 * ancho.
 *
 * Tampoco reusa el shell de la app: ese monta menú lateral, barra superior y
 * todo lo que supone una sesión. Del otro lado hay alguien que no tiene cuenta
 * en Consultek y nunca la va a tener.
 *
 * El ancho se capa en ~900px por el criterio del DS para contenido de lectura:
 * más allá, la línea de texto se vuelve incómoda y la lista de documentos
 * queda con el nombre a la izquierda y el botón perdido a la derecha.
 *
 * SIN el panel de marca con degradado de `AuthLayout`: esto no es una portada,
 * es una herramienta que la persona va a abrir cinco veces mientras junta
 * papeles. El membrete alcanza para saber de quién es la página.
 */
export function PortalLayout({ children }: { children: ReactNode }) {
  return (
    <div className="bg-background flex min-h-screen flex-col">
      <header className="border-border/70 border-b">
        <div className="mx-auto flex w-full max-w-[56rem] items-center gap-2.5 px-6 py-4">
          <img src="/consultek-mark.png" alt="" aria-hidden className="h-8 w-8 object-contain" />
          <span className="text-xl font-extrabold tracking-tight">
            Consul<span className="text-primary">tek</span>
          </span>

          <div className="ml-auto">
            <ThemeToggle />
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[56rem] flex-1 px-6 py-8">{children}</main>

      <footer className="border-border/70 border-t">
        <div className="text-ink-hint mx-auto w-full max-w-[56rem] px-6 py-6 text-center text-xs">
          © {new Date().getFullYear()} Consultek SpA. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
}
